// extracted by mini-css-extract-plugin
export var bonusBlock = "GiftBonusBlock-module--bonusBlock--b3ecc";
export var bonusBlockContent = "GiftBonusBlock-module--bonusBlockContent--b6fcf";
export var bonusBlockItem = "GiftBonusBlock-module--bonusBlockItem--d364a";
export var emphasized = "GiftBonusBlock-module--emphasized--5c3a1";
export var sale = "GiftBonusBlock-module--sale--6a0ce";